// Inquiry.js

import React, {Component} from 'react';
import { Button, Form , Table } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import GTable from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

class InquiryItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible : false
        };
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        // alert(item);
        // this.setState({answervisible:true});
        event.preventDefault();
    }
    render(){
        return (
            <tr onClick={this.handleRowClick}>
            <td>{this.props.item.ID}</td>
            <td>{this.props.item.EMAIL}</td>
            <td>{this.props.item.TITLE}</td>
            <td>{this.props.item.QUESTION}</td>
            <td>{this.props.item.ANSWER ? "OK" : "NO"}</td>
            <td>{this.props.item.REG_DATE}</td>
            </tr>
        );
    }
  };

export default class Inquiry extends Component {
    constructor(props) {
    super(props);
    this.state = {
        value: '제목을 입력하세요.',
        content : '내용을 입력하세요.',
        country : 'KR',
        lang : 'ko',
        contactlist : [],
        sendcount : 0,
        answervisible : false,
        item : { TITLE : '' , QUESTION : '' }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeContent = this.handleChangeContent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.QUESTION = event.target.value;
        this.setState({ item: item });
    }


    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }
    
    handleSubmit(event) {

        this.fetchData('pushto' , {
            ID: this.state.item.ID,
            TITLE: this.state.item.TITLE,
            CONTENT: this.state.item.QUESTION,
            EMAIL: this.state.item.EMAIL,
            TOKEN: this.state.item.TOKEN
        }, (result, count) => {
            console.log('pushto=', count);
            this.setState({sendcount : count})
            this.componentDidMount();

        }, true);    

        event.preventDefault();
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        // alert(item);
        var edititem = {...item};
        edititem.TITLE = "[1:1 문의 답신]" + item.TITLE;
        edititem.QUESTION = "[질문 내용]\n" + item.QUESTION + "\n[답신 내용]\n";

        this.setState({item:edititem});
        this.setState({answervisible:true});
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('contactlist' , {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({contactlist : result})
        }, true);   
    }

    handleScroll(scrollData){
        console.log(scrollData);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({answervisible: false });
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const {rowCount} = this.state;
        let scrollToIndex = Math.min(
          rowCount - 1,
          parseInt(event.target.value, 10),
        );
    
        if (isNaN(scrollToIndex)) {
          scrollToIndex = undefined;
        }
    
        this.setState({scrollToIndex});
    }

    _rowClassName({index}) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    } 

    render(){
        let scrollbarStyles = {borderRadius: 5};
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">1:1 문의(메일)</h3>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({width}) => (
                                            <GTable
                                                ref="Table"
                                                headerClassName={'headerColumn'}
                                                onRowClick={this.handleRowClick}
                                                headerHeight={30}
                                                height={800}
                                                noRowsRenderer={this._noRowsRenderer}
                                                overscanRowCount={10}
                                                rowClassName={this._rowClassName}
                                                rowHeight={40}
                                                rowGetter={({index}) => this.state.contactlist[index]}
                                                rowCount={this.state.contactlist.length}
                                                scrollToIndex={this.state.scrollToIndex}
                                                width={width}>
                                                <Column
                                                width={100}
                                                disableSort
                                                label="#"
                                                dataKey="ID"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={400}
                                                disableSort
                                                label="EMAIL"
                                                dataKey="EMAIL"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={400}
                                                disableSort
                                                label="제목"
                                                dataKey="TITLE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={500}
                                                disableSort
                                                label="질문 내용"
                                                dataKey="QUESTION"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="답신"
                                                dataKey="ANSWER"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData ? "OK" : "NO"}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={200}
                                                disableSort
                                                label="등록일"
                                                dataKey="REG_DATE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                            </GTable>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{  width: '100%' , height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling= {true}
                                            minScrollSize={5}
                                            onScroll={this.handleScroll}
                                            >
                                        <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                            <th>#</th>
                                            <th>EMAIL</th>
                                            <th>제목</th>
                                            <th>질문내용</th>
                                            <th>답신</th>
                                            <th>등록일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { this.state.contactlist.map((item, index) =>
                                            <InquiryItem key={index} item={item} onPress={this.handleRowClick}/>
                                        )}
                                        </tbody>
                                        </Table>
                                        </ScrollArea> */}
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.answervisible} width="80%" effect="fadeInUp" onClickAway={() => this.handleClose()}>
                                            <div style={{ margin: 20 }}>
                                                <h2>문의 내용</h2>
                                                <Form>
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>제목</Form.Label>
                                                        <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.item.TITLE} onChange={this.handleChange}/>
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>내용[답신]</Form.Label>
                                                        <Form.Control as="textarea" rows="10" value={this.state.item.QUESTION} onChange={this.handleChangeContent}/>
                                                    </Form.Group>
                                                    <Button variant="primary" onClick={this.handleSubmit}>전송</Button>
                                                </Form>
                                                <div style={{ height: 5 }}></div>
                                                <Button variant="primary" onClick={this.handleClose}>Close</Button>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Inquiry.js